const localization = {
  en: {
    title: 'Secure Medical Record Access',
    content:
      "Initiate the process to obtain your medical records by clicking the 'Request Medical Records' button below. Your health information, when you need it, securely delivered to you.",
    button: 'Request Medical Records'
  },
  es: {
    title: 'Acceso seguro a expedientes clínicos',
    content:
      "Inicie el proceso para obtener sus expedientes clínicos haciendo clic en el botón 'Solicitar expedientes clínicos' a continuación. Su información de salud, cuando la necesite, se le entregará de forma segura.",
    button: 'Solicitar expedientes clínicos'
  },
  /* eslint-disable no-secrets/no-secrets */
  keyMapping: {
    title: 'UFD_Medical_Record_Access_Title',
    content: 'UFD_Medical_Record_Access_Text',
    button: 'UFD_Medical_Record_Access_Button'
  }
  /* eslint-disable no-secrets/no-secrets */
}

export default localization
